import { ContextFolderIcon, RepoIcon } from '@/components/icons'
import { cn } from '@/lib/utils'
import type { ContextSourceListItem } from '@/types/contextSource'

interface ContextReposBarProps {
  repos: ContextSourceListItem[]
  expiredRepoNames?: Set<string>
}

export function ContextReposBar({ repos, expiredRepoNames }: Readonly<ContextReposBarProps>) {
  if (repos.length === 0) return null

  return (
    <div className="flex items-center gap-3 border-b px-3 py-1 text-foreground">
      <div className="flex items-center gap-1.5 text-sm shrink-0">
        <ContextFolderIcon className="h-4 w-4" />
        <span className="font-medium">Context:</span>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        {repos.map((repo) => {
          const isExpired = expiredRepoNames?.has(repo.name) ?? false
          return (
            <span
              key={repo.id}
              className={cn(
                'flex items-center gap-1.5 rounded-full border px-3 py-0.5 text-sm bg-page',
                isExpired && 'border-danger-foreground bg-danger text-danger-foreground',
              )}
            >
              <RepoIcon className="h-3.5 w-3.5 shrink-0" />
              <span className="truncate">{repo.name}</span>
            </span>
          )
        })}
      </div>
    </div>
  )
}
